import t from "react";
import s from "@appchoose/cn";
import f from "@appchoose/icon";
import * as r from "@radix-ui/react-dialog";
const n = t.forwardRef(
  ({
    type: o = "button",
    appearance: l = "primary",
    size: a = "medium",
    containsIcon: d = !1,
    children: i,
    className: c,
    ...b
  }, p) => {
    const u = (e) => s(
      "inline-flex items-center font-bold transition-colors duration-300 outline-none focus-visible:ring-2 focus-visible:ring-gray-900/30 disabled:cursor-not-allowed",
      {
        rounded: a === "small",
        "rounded-lg": a !== "small",
        "bg-red-600 border-red-600 text-white hover:bg-red-375 hover:border-red-375 disabled:bg-red-300 disabled:border-red-300": e === "danger",
        "bg-gray-900 border-gray-900 text-white hover:bg-gray-700 hover:border-gray-700 disabled:bg-gray-300 disabled:border-gray-300": !e || e === "primary",
        "bg-white text-gray-900 border-gray-900 hover:text-gray-700 hover:border-gray-700 disabled:text-gray-300 disabled:border-gray-300": e === "outline"
      }
    ), g = (e) => s({
      border: e === "small",
      "border-2": e !== "small",
      "text-xs p-1.75": (!e || e === "small") && d,
      "text-xs px-2.5 py-1.75": (!e || e === "small") && !d,
      "text-sm px-3.5 py-2": (!e || e === "medium") && !d,
      "text-sm p-1.5": (!e || e === "medium") && d,
      "text-md px-9.5 py-3.5": e === "large" && !d,
      "text-md p-4": e === "large" && d
    });
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        ref: p,
        type: o,
        className: s(
          u(l),
          g(a),
          c
        ),
        ...b
      },
      i
    );
  }
);
n.displayName = "Button";
const R = r.Root, C = r.Trigger, y = r.Close, x = r.Portal, m = t.forwardRef(({ className: o, ...l }, a) => /* @__PURE__ */ t.createElement(
  r.Overlay,
  {
    ref: a,
    className: s(
      "fixed inset-0 z-40 bg-black/30 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      o
    ),
    ...l
  }
));
m.displayName = r.Overlay.displayName;
const h = t.forwardRef(({ className: o, children: l, left: a = !1, ...d }, i) => /* @__PURE__ */ t.createElement(x, null, /* @__PURE__ */ t.createElement(m, null), /* @__PURE__ */ t.createElement(
  r.Content,
  {
    ref: i,
    className: s(
      "fixed inset-y-0 z-40 h-full w-screen bg-white data-[state=closed]:duration-300 data-[state=open]:duration-300 data-[state=closed]:ease-in-out-cubic data-[state=open]:ease-in-out-cubic data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      {
        "left-0 data-[state=closed]:slide-out-to-left-full data-[state=open]:slide-in-from-left-full": a,
        "right-0 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-right-full": !a
      },
      o
    ),
    ...d
  },
  l,
  /* @__PURE__ */ t.createElement(y, { asChild: !0 }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: s("absolute top-0 flex pt-6", {
        "right-0 -mr-14": a,
        "left-0 -ml-14": !a
      })
    },
    /* @__PURE__ */ t.createElement(n, { type: "button", containsIcon: !0, id: "sidebar__close-button" }, /* @__PURE__ */ t.createElement(f, { icon: "close", size: "large", className: "text-white" }))
  ))
)));
h.displayName = r.Content.displayName;
const N = t.forwardRef(({ className: o, ...l }, a) => /* @__PURE__ */ t.createElement(
  r.Title,
  {
    ref: a,
    className: s("text-2xl font-bold text-gray-900", o),
    ...l
  }
));
N.displayName = r.Title.displayName;
const v = t.forwardRef(({ className: o, ...l }, a) => /* @__PURE__ */ t.createElement(r.Description, { ref: a, className: o, ...l }));
v.displayName = r.Description.displayName;
export {
  R as Sidebar,
  y as SidebarClose,
  h as SidebarContent,
  v as SidebarDescription,
  m as SidebarOverlay,
  N as SidebarTitle,
  C as SidebarTrigger
};
